// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2186":"69a90d98","4509":"c8def894","5787":"f9360698","6904":"b6c9bf7e"}[chunkId] + ".chunk.css";
};